import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class OpenNewWindowMessage extends WebViewMessage {
  public constructor(
    public width: number | undefined,
    public height: number | undefined,
    public top: number | undefined,
    public left: number | undefined,
    public url: string | undefined,
  ) {
    super(MessageType.OpenNewWindow);
  }
}
